import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ReporterDashboard from "@/pages/ReporterDashboard";
import QuickReportPage from "@/pages/QuickReportPage";
import MyReportsPage from "@/pages/MyReportsPage";
import OfficerDashboard from "@/pages/OfficerDashboard";
import OfficerReportDetail from "@/pages/OfficerReportDetail";
import AdminDashboard from "@/pages/AdminDashboard";
import InstitutionsManagement from "@/pages/InstitutionsManagement";
import UsersManagement from "@/pages/UsersManagement";
import SettingsPage from "@/pages/SettingsPage";

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen bg-[#0A0A0A]"><div className="text-white font-heading text-xl">Yükleniyor...</div></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function RoleRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen bg-[#0A0A0A]"><div className="text-white font-heading text-xl">Yükleniyor...</div></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  if (user.role === "officer") return <Navigate to="/officer" replace />;
  return <Navigate to="/reporter" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/" element={<RoleRedirect />} />
          <Route path="/reporter" element={<ProtectedRoute roles={["reporter"]}><ReporterDashboard /></ProtectedRoute>} />
          <Route path="/reporter/record" element={<ProtectedRoute roles={["reporter"]}><QuickReportPage /></ProtectedRoute>} />
          <Route path="/reporter/reports" element={<ProtectedRoute roles={["reporter"]}><MyReportsPage /></ProtectedRoute>} />
          <Route path="/officer" element={<ProtectedRoute roles={["officer"]}><OfficerDashboard /></ProtectedRoute>} />
          <Route path="/officer/report/:id" element={<ProtectedRoute roles={["officer"]}><OfficerReportDetail /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/institutions" element={<ProtectedRoute roles={["admin"]}><InstitutionsManagement /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute roles={["admin"]}><UsersManagement /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute roles={["admin"]}><SettingsPage /></ProtectedRoute>} />
          <Route path="/admin/report/:id" element={<ProtectedRoute roles={["admin"]}><OfficerReportDetail /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: { background: '#1C1C1E', border: '1px solid #2C2C2E', color: '#fff' }
        }}
      />
    </AuthProvider>
  );
}

export default App;
